import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

import { ButtonLinkComponent } from '@mode/capra';
import { SharedUtilToastModule, ToastAnimation } from '@mode/shared/util-toast';
import { SharedUtilDomModule } from '@mode/shared/util-js';

@Component({
  standalone: true,
  selector: 'mode-export-dataset-success',
  imports: [ButtonLinkComponent, SharedUtilToastModule, SharedUtilDomModule],
  templateUrl: './export-dataset-success.component.html',
  styleUrls: ['./export-dataset-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [ToastAnimation],
})
export class ExportDatasetSuccessComponent extends Toast {
  exportedDatasetLink = this.options.payload.exportedDatasetLink;

  dismissToast() {
    this.remove();
  }
}
